import { signIdDetail } from "./signId_reducer";

export const signId_action = (query) => async (dispatch) => {
    try {
        dispatch(signIdDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};